// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT, COMMIT, or PUSH!
/* tslint:disable */
export const version = {
  "name": "@eai3537532/wpro",
  "version": "4.22.5",
  "description": "WPRO",
  "hash": "8dacace",
  "build": "2026-10-13T17:14:28.080Z"
};
/* tslint:enable */
